import styled, { useTheme } from 'styled-components';
import { TickIcon } from '../icons/tick-icon';
import { ListItem } from './list-item';

export interface Option {
  display: string;
  value: string;
}

export interface MultiChoiceListProps {
  options: Option[];
  selectedOptions: Option[];
  onSelect: (option: Option[]) => void;
  disabledOptions?: Option[];
  renderOption?: (option: Option, isDisabled: boolean, isSelected: boolean) => React.ReactElement;
}

export const MultiChoiceList: React.FC<MultiChoiceListProps> = ({
  options,
  selectedOptions,
  onSelect,
  disabledOptions = [],
  renderOption,
}) => {
  const theme = useTheme();
  return (
    <>
      {options.map((option) => {
        const isSelected = selectedOptions.some((selectedOption) => selectedOption.value === option.value);
        const isDisabled =
          disabledOptions && disabledOptions.some((disabledOption) => disabledOption.value === option.value);
        const showTick = isSelected || isDisabled;

        return (
          <ListItem
            data-testid={`multi-choice-list-${option.display}`}
            key={`${option.display}-${option.value}`}
            isSelected={isSelected}
            isDisabled={isDisabled}
            onClick={() => {
              if (isDisabled) {
                return;
              } else if (isSelected) {
                onSelect(selectedOptions.filter((selectedOption) => selectedOption.value !== option.value));
              } else {
                onSelect([...selectedOptions, option]);
              }
            }}
          >
            <S.OptionContainer>
              {renderOption ? renderOption(option, isDisabled, isSelected) : option.display}
              {showTick && <TickIcon color={isDisabled ? theme.secondary.softBlue1 : theme.main.deepBlue} />}
            </S.OptionContainer>
          </ListItem>
        );
      })}
    </>
  );
};

const S = {
  OptionContainer: styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-left: 8px;
    width: 100%;
  `,
};
